<template>
  <div class="debrief">
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="upload">
        <div class="label">
          <i class="fa fa-cog fa-spin fa-3x fa-fw"></i> <br/>
          {{ message }}
        </div>
      </div>
    </transition>
    <div class="header-intervention">
      <div class="header-info">
      </div>
      <div class="button-content">
        <div class="button" @click="back() " v-if="photo">
          <i class="fa fa-times" aria-hidden="true"></i> Annuler
        </div>
        <div class="button" @click="startDebrief()" v-if="photo">
          <i class="fa fa-pencil-square-o"></i> Debrief
        </div>
        <div class="button" @click="backPhoto()" v-if="debrief_started">
          <i class="fa fa-chevron-left" aria-hidden="true"></i> Retour
        </div>
        <div class="button" @click="uploadPicture" v-if="debrief_started">
          <i class="fa fa-paper-plane" aria-hidden="true"></i> Envoyer
        </div>
      </div>
    </div>
    <b-container :class="wrapper_class">
      <div v-show="photo">
        <div class="picture" v-for="(file, index) in types_photo" :key="index">
          <div class="label">{{file.description}}</div>
          <img class="preview" v-if="file.image" v-bind:src="file.image" alt="">
          <div class="picture-placeholder" v-else>Photo manquante</div>
          <div class="options">
            <div class="rename" v-on:click="setPicture(file)">{{file.image ? 'Modifier' : 'Ajouter'}}</div>
          </div>
        </div>
        <div class="picture" v-for="(file, index) in files" :key="index">
          <div class="label">{{file.description}}</div>
          <img class="preview" v-bind:src="file.image" alt="">
          <div class="options">
            <div class="rename" v-on:click="rename(file)">Renommer</div>
            <div class="delete" v-on:click="deleteFile(file)">Supprimer</div>
          </div>
        </div>
        <div class="buttonPhoto" v-on:click="setPicture()">
          <i class="fa fa-camera" aria-hidden="true"></i> Ajouter des photos
        </div>
        <input ref="fileInput" type="file" accept="image/*" @change="onFileChange">
      </div>
      <div class="content-arbre" v-show="!photo">

      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AuditConstatation',
  props: {
    isTest: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: '',
      photo: true,
      types_photo: [], // contient les photos qui doivent obligatoirement être ajoutée
      files: [], // contient les photos ajoutée à l'initiative de l'utilisateur
      intervention_id: null,
      debrief: {},
      reponse_count: 0,
      intervention: {},
      upload: false,
      message: '',
      debrief_started: false,
      waiting: {
        position: 0,
        total: 0
      },
      wrapper_class: 'debrief-content'
    }
  },
  methods: {
    back: function () {
      this.$router.push('/intervention/' + this.intervention_id)
    },
    backPhoto () {
      this.debrief_started = false
      this.photo = true
    },
    startDebrief () {
      if (this.types_photo.find(type => !type.image)) {
        this.$toast(`Il manque la photo ${this.types_photo.find(type => !type.image).description}`)
        return false
      }
      this.intervention.files = [...this.types_photo, ...this.files]
      this.$setItem(this.intervention_id, this.intervention, (err) => {
        if (err) alert(err)
        this.photo = false
        this.debrief_started = true
        window.scrollTo(0, 0)
      })
    },
    setPicture: function (file = null) {
      if (file) this.selected = file.description
      this.$refs.fileInput.click()
    },
    uploadPicture: function () {
      let files = [...this.types_photo, ...this.files]
      if (this.waiting.position >= files.length) {
        this.upload = false
        this.waiting.position = 0
        this.waiting.total = 0
        this.files.length = 0
        this.send()
      } else {
        this.upload = true
        this.waiting.total = files.length
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total
        this.uploadPictureServer(files[this.waiting.position])
      }
    },
    uploadPictureServer: function (data) {
      this.$http.post('intervention/' + this.intervention_id + '/photo', JSON.stringify(data)).then(response => {
        this.response = response.json().then((data) => {
          this.waiting.position++
          this.uploadPicture()
        })
      }, (response) => {
        console.log(response)
      })
    },
    rename: function (file) {
      file.description = prompt('Nommer la photo', file.description)
    },
    getTypesPhoto () {
      this.$http.get('typephoto').then(response => {
        this.types_photo = response.body.filter(elt => elt.type_intervention_id === this.intervention.typeId).map(type => ({...type, description: type.nom, required: true}))
      }).catch(() => this.$toast.bottom('Les types de photo n\'ont pas pu être chargés.'))
    },
    deleteFile: function (file) {
      let i = this.files.indexOf(file)
      if (i !== -1) {
        this.files.splice(i, 1)
      }
    },
    onFileChange: function (e, prefill) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      let _this = this
      for (let i in files) {
        let file = files[i]

        if (!(file instanceof File)) {
          continue
        }
        let reader = new FileReader()
        reader.onload = function (e) {
          let image = new Image()
          image.src = e.target.result
          image.onload = function () {
            let maxWidth = 1024
            let maxHeight = 768
            let imageWidth = image.width
            let imageHeight = image.height

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth
                imageWidth = maxWidth
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight
                imageHeight = maxHeight
              }
            }
            let canvas = document.createElement('canvas')
            canvas.width = imageWidth
            canvas.height = imageHeight
            image.width = imageWidth
            image.height = imageHeight
            let ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight)
            if (_this.selected) {
              _this.types_photo = _this.types_photo.map(type => {
                if (type.description !== _this.selected) return type
                return {...type, image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg')}
              })
              _this.selected = null
            } else {
              _this.files.push({
                image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
                description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
              })
            }
            _this.$refs.fileInput.value = ''
          }
        }
        reader.readAsDataURL(file)
      }
    },
    send: function () {
      let send = []
      $('.content > .question').each(function (index) {
        if ($(this).is(':visible')) {
          if ($(this).find('.reponse-button').hasClass('check')) {
            send.push({
              question_id: $(this).find('.reponse-button.check').data('question-id'),
              response_id: $(this).find('.reponse-button.check').data('reponse-id')
            })
          }
          if ($(this).find('.reponse-input > input').val() !== '' && $(this).find('.reponse-input > input').val() !== undefined) {
            send.push({
              question_id: $(this).find('.reponse-input').data('question-id'),
              response_id: null,
              response_text: $(this).find('.reponse-input > input').val()
            })
          }
        }
      })
      this.$http.post('intervention/' + this.intervention_id + '/action/debrief', {debrief: send}).then(response => {
        this.$removeItem(this.intervention_id)
        this.$router.push('/intervention/' + this.intervention_id)
        this.$toast.bottom('Intervention terminée')
      }).catch(err => {
        if (err.status === 403) {
          this.$router.push('/intervention/' + this.intervention_id)
          this.$toast.bottom('Le debrief n\'a pas pu être debriefer car la date de rendez vous a été modifié !')
        }
        this.$toast.bottom('Une erreur est survenue lors de l\'envoi du debrief')
      })
    },
    count: function () {
      let t = 0
      $('.content > .question').each(function (index) {
        if ($(this).data('required')) {
          if ($(this).is(':visible')) {
            if ($(this).has('.reponse-button').length !== 0) {
              if ($(this).find('.reponse-button').not('.check').length === $(this).find('.reponse-button').length) {
                t++
              }
            }
            if ($(this).find('.reponse-input > input').val() === '') {
              t++
            }
          }
        }
      })
      this.reponse_count = t
    },
    arbre: function (debrief) {
      let html = ''
      for (let i in debrief) {
        let required = ''
        if (debrief[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>'
        }
        html += '<div class="content debrief"><div class="question" data-required="' + debrief[i]['required'] + '" data-question-id="' + debrief[i]['question_id'] + '"> <div class="label">' + debrief[i]['question_label'] + ' ' + required + '</div>'
        for (let b in debrief[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + debrief[i]['question_id'] + '" data-reponse-id="' + debrief[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + debrief[i]['reponse'][b]['reponse_label'] + '</div>'
        }
        if (debrief[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + debrief[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>'
        }
        html += '</div>'
        for (let b in debrief[i]['reponse']) {
          if (debrief[i]['reponse'][b]['next_question'] !== null) {
            html += '<div class="child next_question_' + debrief[i]['reponse'][b]['reponse_id'] + '"> ' + this.recursive(debrief[i]['reponse'][b]['next_question'], '') + '</div>'
          }
        }
        html += '</div>'
      }
      $('.content-arbre').append(html)
      let _this = this
      $('.reponse-input > input').keyup(function () {
        _this.count()
      })
      $('.action').on('click', function () {
        // let id = $(this).data('reponse-id')
        $(this).parent().find('.action').each(function (index) {
          $(this).removeClass('check')
          $(this).find('.fa').addClass('hide')
        })
        $(this).parent().parent().find('.child').each(function (index) {
          $(this).children('.content').hide()
        })
        $(this).addClass('check')
        $(this).find('.fa').removeClass('hide')
        $(this).parent().parent().find('.child').children('.content').find('.condition').each(function (index) {
          let json = JSON.parse($(this).text())
          let ok = 0
          let count = json.length === undefined ? 0 : json.length
          for (let i in json) {
            let id = json[i]['reponse_id']
            if (json[i]['has_this_value'] === 0) {
              if (!$('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++
              }
            } else {
              if ($('[data-reponse-id="' + id + '"]').hasClass('check')) {
                ok++
              }
            }
          }
          if (ok === count) {
            $(this).parent().show()
          }
        })

        _this.count()
      })

      this.count()
    },
    recursive: function (data, html) {
      for (let i in data) {
        let required = ''
        if (data[i]['required']) {
          required = '<div class="required">( Réponse obligatoire )</div>'
        }
        html += '<div class="content debrief sub hide"><div class="condition hide">' + JSON.stringify(data[i]['condition']) + '</div><div class="question" data-required="' + data[i]['required'] + '" data-question-id="' + data[i]['question_id'] + '"> <div class="label">' + data[i]['question_label'] + ' ' + required + '</div>'
        for (let b in data[i]['reponse']) {
          html += '<div class="reponse-button action" data-question-id="' + data[i]['question_id'] + '" data-reponse-id="' + data[i]['reponse'][b]['reponse_id'] + '"><i class="fa fa-check hide" aria-hidden="true"></i> ' + data[i]['reponse'][b]['reponse_label'] + '</div>'
        }
        if (data[i]['custom_response']) {
          html += '<div class="reponse-input" data-question-id="' + data[i]['question_id'] + '"><input type="text" placeholder="Votre réponse"/></div>'
        }
        html += '</div>'
        for (let b in data[i]['reponse']) {
          if (data[i]['reponse'][b]['next_question'] !== null) {
            html += '<div class="child next_question_' + data[i]['reponse'][b]['reponse_id'] + '"> ' + this.recursive(data[i]['reponse'][b]['next_question'], '') + '</div>'
          }
        }
        html += '</div>'
      }
      return html
    }
  },
  mounted: function () {
    this.photo = true
    this.$modal.hide('selector')
    let _this = this
    this.intervention_id = this.$route.params.intervention_id
    let data = localStorage.getItem('debrief_' + this.intervention_id)
    this.$getItem(this.intervention_id, function (err, intervention) {
      if (err) return
      _this.intervention = intervention
      if (!intervention.files) _this.getTypesPhoto()
      else {
        _this.types_photo = intervention.files.filter(file => file.required)
        _this.files = intervention.files.filter(file => !file.required)
      }
    })

    if (data) {
      this.debrief = JSON.parse(data)
      this.arbre(this.debrief)
    }
  }
}
</script>
<style>
.content.debrief{
  position: relative;
  background: #ffffff;
  margin-bottom: 10px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  box-shadow: 0 1px 1px rgba(0,0,0,0.4);
  color: #444;
  background-repeat: no-repeat;
  background-position: bottom 5px right 10px;
  background-size: 15%;
  padding: 10px 10px 10px;
  border-top: 2px solid rgb(230, 68, 68) !important;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.content.sub{
  border-top: none !important;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-left: 3%;
  margin-top: 20px;
  width: calc(100% - 3%);
  border-left: 2px solid rgb(230, 68, 68) !important;
  box-shadow: 0 1px 1px rgba(0,0,0,0.3);
}
.reponse-input
{
  margin-left: auto;
  margin-right: auto;
}
.reponse-input > input{
  text-align: center;
  padding: .48rem .75rem;
  font-size: 1rem;
  line-height: 1;
  color: #464a4c;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  display: inherit;
  background-color: #fff;
  background-image: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25rem;
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
}
.rules{
  font-size: 14px;
}
.required{
  color: green;
  font-size: 13px;
}
.hide{
  display: none;
}
.action.check{
  border: 1px solid green !important;
  color: white;
  background-color: green;
}
.question > .label{
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.reponse-button{
  color: rgb(230, 68, 68);
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border: 1px solid rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.5rem 0.5rem;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 5px;
}

</style>
<style scoped>
  .header-info{
    display: inline-block;
    position: absolute;
    left: 16px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    top: 71px;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    text-align: center;
  }
  .button-content{
    position: absolute;
    right: 16px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    top: 71px;
  }
  .button-content > .button{
    display: inline-block;
    background-color: rgb(230, 68, 68) !important;
    border-color: rgb(230, 68, 68) !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0.2rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    margin-left: 10px;
  }
  .debrief-content {
    margin-top: 110px;
    padding-top: 30px;
  }
  .picture{
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    display: inline-block;
    width: 43vw;
    padding: 10px;
    margin-left: 2vw;
    margin-bottom: 2vh;
  }
  .picture > .label{
    text-align: center;
    margin-bottom: 10px;
  }
  .picture > .options{
    text-align: center;
  }
  .picture > .options > div{
    text-align: center;
    background-color: rgb(230, 68, 68);
    margin-top: 5px;
    font-size: 14px;
    padding: 5px;
    color: white;
  }
  .picture-placeholder {
    text-align: center;
    font-size: small;
    color: red;
    padding-bottom: 15px;
  }
  .buttonPhoto{
    height: 50px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border: 1px solid rgb(230, 68, 68);
    width: 97%;
    margin-right: 4px;
    margin-left: auto;
    text-align: center;
    background-color: white;
    color:rgb(230, 68, 68);
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .buttonPhoto .fa{
    font-size: 15px;
    margin-top: 18px;
  }
  input[type=file] {
    display: none;
  }
  .preview{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
  .loading{
    position: fixed;
    text-align: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.7);
    z-index: 9999;
    color: white;
    top: 55px;
  }
  .loading > .label{
    padding-top: 35vh;
  }
  .title-selector{
    text-align: center;
    padding-top: 6px;
  }
  .select{
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AuditConstatation.vue